import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import PageContentWrapper from '../pages/components/pageContentWrapper';
import { getTripNotification } from '../service/tripNotificationService';
import { TripNotificationPage } from './TripNotificationPage';
import { TripNotification } from '../types/tripNotification';

const TripNotificationContainer: React.FC = () => {
  const { tripId, notificationId } = useParams<Record<string, string>>();
  const [loading, setLoading] = useState(false);
  const [hasGetTripNotificationError, setHasGetTripNotificationError] = useState(false);
  const [tripNotification, setTripNotification] = useState<TripNotification | null>(null);

  useEffect(() => {
    const fetchTripNotification = async () => {
      setLoading(true);
      try {
        if (tripId && notificationId) {
          const response = await getTripNotification(tripId, notificationId);
          setTripNotification(response);
        }
      } catch (_error) {
        setTripNotification(null);
        setHasGetTripNotificationError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchTripNotification();
  }, [tripId, notificationId]);

  return (
    <PageContentWrapper loading={loading} title="TRIP ALERT MESSAGE">
      <TripNotificationPage
        tripNotification={tripNotification}
        hasGetTripNotificationError={hasGetTripNotificationError}
      />
    </PageContentWrapper>
  );
};

export default TripNotificationContainer;